export default (params) => ({
  trigger: {
    name: 'assortment_entrance_navigation.select_navigation',
    params: params,
  },
  config: {
    schema: {
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      url: {
        type: 'string',
      },
      redirect: {
        type: 'string',
      },
      sub_feature: {
        enum: [
          'primary_category',
          'secondary_category',
          'tertiary_category',
        ],
      },
    },
    event: {
      name: 'select_navigation',
    },
  },
});
